import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { getValidationStateErrorsChangesDeep } from 'src/util/angular/ng-forms-validation';

@Component({
  selector: 'fl-billing-summary',
  templateUrl: './billing-summary.component.html',
  styleUrls: ['./billing-summary.component.scss'],
})
export class BillingSummaryComponent implements OnInit {
  @Input()
  public billingSummary: UntypedFormGroup;

  public validationErrors$: Observable<string[]>;

  public ngOnInit() {
    this.validationErrors$ = getValidationStateErrorsChangesDeep(this.billingSummary);
  }
}
